module.exports = __webpack_public_path__ + "img/pr-11.95f1f9f8.png";